export default __webpack_public_path__ + "static/LogoETH-e7c2ba5455b32ceb259a788780efe887.svg";